import { render } from "./CounterAnimate.vue?vue&type=template&id=b8753616"
import script from "./CounterAnimate.vue?vue&type=script&lang=js"
export * from "./CounterAnimate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CounterAnimate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b8753616"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b8753616', __exports__)) {
    api.reload('b8753616', __exports__)
  }
  
  module.hot.accept("./CounterAnimate.vue?vue&type=template&id=b8753616", () => {
    api.rerender('b8753616', render)
  })

}


export default __exports__